<template>
  <span class="search-highlight-text">
    <span v-for="(frag, i) in fragments" :key="i">
      <mark v-if="frag.highlight" class="search-highlight">{{ frag.text }}</mark>
      <template v-else>{{ frag.text }}</template>
    </span>
  </span>
</template>

<script>
import { computed } from 'vue'
import { splitHighlightFragments } from './searchHighlight'

export default {
  name: 'SearchHighlightText',
  props: {
    text: { type: [String, Number], default: '' },
    keyword: { type: String, default: '' },
  },
  setup(props) {
    const fragments = computed(() => splitHighlightFragments(props.text, (props.keyword || '').trim()))
    return { fragments }
  },
}
</script>

<style>
.search-highlight {
  background-color: #ffe58f;
  padding: 0;
}
</style>
